import { CommonModule, NgOptimizedImage } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SeoService } from '@app/services';
import { I18nModule, PageMetaResolver } from 'haba-core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HabaProItemCounterModule } from '@app/common';
import { ContentfulModule } from '@app/contentful';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { ItemCounterModule } from 'haba-storefrontlib';
import { GlobalMessageCustomComponentModule } from 'src/app/misc/global-message/global-message-custom.module';
import { ProductDetailsComponent } from 'src/app/product/product-detail/product-details.component';
import { UserModule } from 'src/app/user/user.module';

//import { WishlistSharedModule } from 'src/app/wishlist/@shared/wishlist-shared.module';
import { RouterModule } from '@angular/router';
import { MainPipeModule } from '@app/helpers';
import { CloudinaryModule } from '@cloudinary/ng';
import { ProductCardBaseModule } from 'src/app/product/product-card-base/product-card-base.module';
import { ProductCardComponent } from 'src/app/product/product-card/product-card.component';
import { StockInformationComponent } from 'src/app/product/product-detail/stock-information/stock-information.component';
import { ProductGalleryComponent } from 'src/app/product/product-gallery/product-gallery.component';

import { NgSelectModule } from '@ng-select/ng-select';
import { ProductVariantDropDownSelectorComponent } from 'src/app/product/product-variant-dropdown-selector/product-variant-dropdown-selector.component';
import { ProductVariantsContainerComponent } from 'src/app/product/product-variants-container/product-variants-container.component';

import { SwiperModule } from 'swiper/angular';
import { AddToCartPopupModule } from '../cart/add-to-cart-popup/add-to-cart-popup.module';
import { AddToCartModule } from '../cart/add-to-cart/add-to-cart.module';
import { CartCustomModule } from '../cart/cart-custom.module';
import { ConfiguratorModule } from '../configurator/configurator.module';
import { ProductDetailsPriceDisplayModule } from './product-details-price-display.module';
import { ProductGalleryModalComponent } from './product-gallery/product-gallery-modal/product-gallery-modal.component';

@NgModule({
  imports: [
    NgbAccordionModule,
    CommonModule,
    CartCustomModule,
    CloudinaryModule,
    MainPipeModule,
    I18nModule,
    UserModule,
    GlobalMessageCustomComponentModule,
    ItemCounterModule,
    ReactiveFormsModule,
    HabaProItemCounterModule,
    //WishlistSharedModule,
    ProductCardBaseModule,
    RouterModule,
    ContentfulModule,
    NgSelectModule,
    FormsModule,
    SwiperModule,
    AddToCartModule,
    AddToCartPopupModule,
    ProductDetailsPriceDisplayModule,
    ConfiguratorModule,
    ProductDetailsComponent,
    StockInformationComponent,
    ProductGalleryComponent,
    ProductCardComponent,
    ProductVariantsContainerComponent,
    ProductVariantDropDownSelectorComponent,
    ProductGalleryModalComponent,
    NgOptimizedImage,
  ],
  providers: [
    {
      provide: PageMetaResolver,
      useExisting: SeoService,
      multi: true,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProductModule {}
